import { useContext } from 'react';
import { DrawerContext } from '../DrawerProvider.js';

const useCloseDrawer = () => {
    const context = useContext(DrawerContext);
    return () => {
        if (context.close) {
            context.close();
        }
    };
};

export { useCloseDrawer };
//# sourceMappingURL=useCloseDrawer.js.map
